// MSSQL normalizer — routes T-SQL connections through the per-dialect
// tree-sitter grammar fork (resources/tree-sitter/mssql.wasm) instead of the
// legacy unified scanner. PRD: Ralph/SqlGrammar2/PRD.md Slice 2.5.
//
// Slice 3.5 collapsed the previously-duplicated body into
// `normalize/shared/createForkNormalizer.ts` — this module now binds the
// factory to the MSSQL parser singleton and re-exports the loader seams.

import { createForkNormalizer } from '../shared/createForkNormalizer';
import { getMssqlParser } from './parser';

const normalizer = createForkNormalizer({ engine: 'mssql', getParser: getMssqlParser });

export const buildParsedDocument = normalizer.buildParsedDocument;
export const getDocumentStructure = normalizer.getDocumentStructure;

export { setMssqlWasmLoader, getMssqlParser, __resetMssqlParserForTest } from './parser';
export type { MssqlWasmLoader } from './parser';
